document.documentElement.classList.remove("no-js");
window.addEventListener('DOMContentLoaded', function () {
  //lazy load
  yall({
    threshold: 150,
    observeChanges: true,
    events: {
      load: function () {
        if (!event.target.classList.contains("dropin") && event.target.nodeName == "IMG") {
          event.target.classList.add("is-loaded");
        }
      }
    }
  });
  //header
  window.addEventListener('scroll', function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      document.querySelector('header').classList.add('is_fixed');
    } else {
      document.querySelector('header').classList.remove('is_fixed')
    }
  });

  //header search
  document.querySelector(".header_menu .search").addEventListener('click', function () {
    document.querySelector(".header_inner").classList.toggle('is_open');
    setTimeout(function () {
      document.getElementById('search_box').focus();
      var val = this.document.getElementById('search_box').value;
      this.document.getElementById('search_box').value = '';
      this.document.getElementById('search_box').value = val
    }, 500);
  });
  document.querySelector("#cancel").addEventListener('click', function () {
    document.querySelector(".header_inner").classList.remove('is_open');
  });

  //side menu
  document.querySelector("#menu").addEventListener('click', function () {
    document.querySelector(".side_menu").classList.add("open");
  });
  document.querySelector(".side_menu .close").addEventListener('click', function () {
    document.querySelector(".side_menu").classList.remove("open");
  });
  document.querySelector(".side_menu").addEventListener('click', function (e) {
    if (!e.target.closest(".menu")) {
      document.querySelector(".side_menu").classList.remove("open");
    }
  });

  //anchor scroll
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

  anchorLinksArr.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.hash;
      const targetElement = document.querySelector(targetId);
      const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - 80;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth"
      });
    });
  });

  //header news
  if (document.getElementsByClassName("header_news").length > 0) {
    new Splide('.header_news', {
      direction: 'ttb',
      loop: true,
      type: 'loop',
      height: '50px',
      autoplay: true,
      pagination: false,
      arrows: false,
      drag:false,
      rewind: false,
    }).mount();
  }

  //top slide
  if (document.getElementsByClassName("top").length > 0){
    new Splide('.top', {
      label: 'top',
      type: 'loop',
      rewind: true,
      autoplay: true,
      interval: 3000,
      speed: 500,
      rewindByDrag: true,
      drag: document.querySelector('.top .splide__list').childElementCount > 1,
      live: true,
      pagination: true,
      arrows: false,
    }).mount();
  }

  // howto
  if (document.getElementsByClassName("how_to").length > 0) {
    new Splide('.how_to', {
      type: 'slide',
      rewind: true,
      rewindByDrag: false,
      speed: 600,
      pagination: true,
      updateOnMove: true,
      arrows: false,
      drag: false,
      lazyLoad: 'nearby',
      perPage: 3,
      gap: '20px',
      padding: { left: 20, right: 20 },
      breakpoints: {
        640: {
          type: 'slide',
          padding: { left: 20, right: 20 },
          perPage: 'auto',
          drag: 'free',
          focus: 'center',
          fixedWidth: '60%',
        },
      },
    }).mount();
  }

  //featured slide
  featured();

  //ranking
  ranking();

  //looks
  looks();

  //video
  if (document.querySelectorAll(".plyr").length > 0) {
    const players = Array.from(document.querySelectorAll('.plyr')).map((p, index) => {
      const player = new Plyr(p, {
        autoplay: true,
        playsinline: true,
        loop: { active: true },
        muted: true,
        hideControls: false,
        clickToPlay: false,
        controls: ['mute']
      });
      return player;
    });
  }

  // carousel
  if (document.getElementsByClassName("carousel").length > 0) {
    new Splide('.carousel', {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: 4000,
      speed: 4000,
      arrows: document.querySelector('.carousel .splide__list').childElementCount > 1,
      lazyLoad: 'sequential',
      pagination: false
    }).mount();
  }

  //model view
  if (document.getElementById("model_view") != null) {
    document.querySelector('#model_view').addEventListener('change', function () {
      if (this.checked) {
        Array.prototype.slice.call(document.querySelectorAll(".product")).forEach(function (element) {
          element.classList.add("model");
        });
      } else {
        Array.prototype.slice.call(document.querySelectorAll(".product")).forEach(function (element) {
          element.classList.remove("model");
        });
      }
    });
  }

  //filters
  if (document.getElementById("filter") != null) {
    document.getElementById("filter").addEventListener('click', function () {
      document.getElementById("filters").classList.add('open');
    });
    document.querySelector(".filters_close").onclick = function () {
      document.getElementById('filters').classList.remove('open');
    }
    document.querySelector(".filters_content h3").addEventListener('touchmove', function (e) {
      setTimeout(function () {
        document.getElementById('filters').classList.remove('open');
      }, 200);
    });
  }

  //collection sort
  if (document.querySelector('select[name="sort_by"]') !== null) {
    document.querySelector('select[name="sort_by"]').addEventListener('change', function () {
      var selectedValue = this.value;
      var currentURL = window.location.href;
      var urlSearchParams = new URLSearchParams(currentURL);
      var sortParam = urlSearchParams.get("sort_by");

      if (sortParam !== null) {
        currentURL = currentURL.replace("sort_by=" + sortParam, "sort_by=" + selectedValue);
      } else {
        currentURL += (currentURL.indexOf("?") !== -1 ? "&" : "?") + "sort_by=" + selectedValue;
      }

      window.location.href = currentURL;
    });
  }

  //category filter
  if (document.querySelector('select[name="filter.p.m.category.sub"]') !== null) {
    document.querySelector('select[name="filter.p.m.category.sub"]').addEventListener('change', function () {
      var texture = document.querySelectorAll('input[name="filter.p.tag"]');
      texture.forEach(function (checkbox) {
        checkbox.checked = false;
      });

      if (this.value == "マスカラ"){
        document.querySelector(".texture_list").classList.add("disabled");
        document.querySelector(".texture_list").classList.remove("disabled-gloss");
      } else if (this.value == "パウダーアイシャドウ"){
        document.querySelector(".texture_list").classList.remove("disabled");
        document.querySelector(".texture_list").classList.add("disabled-gloss");
      } else if (this.value == "ケアアイテム" || this.value == "ベーシックアイテム" ) {
        document.querySelector(".texture_list").classList.add("disabled");
      } else {
        document.querySelector(".texture_list").classList.remove("disabled");
        document.querySelector(".texture_list").classList.remove("disabled-gloss");
      }
    });
  }

  //mailmagazine
  if (window.location.href.includes("?contact%5Btags%5D=newsletter&form_type=customer")) {
    var element = document.getElementById("Newsletter-error");
    element.classList.remove("magazine_hidden");
  }

  //light box
  var lightbox = new PhotoSwipeLightbox({
    gallery: '.overview,.product_looks,.color_list',
    children: 'li:not(.splide__slide--clone) a',
    bgOpacity: 0.4,
    initialZoomLevel: 'fit',
    secondaryZoomLevel: 'fill',
    imageClickAction: 'zoom-or-close',
    tapAction: 'next',
    doubleTapAction: 'close',
    showHideAnimationType: 'fade',
    pswpModule: PhotoSwipe,
    preloadFirstSlide: true
  });
  lightbox.init();

});

function ranking() {
  var elms = document.getElementsByClassName("splide_tab");
  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      perPage: 5,
      perMove: 1,
      gap: '20px',
      padding: { left: 20, right: 20 },
      arrows: false,
      focus: 0,
      live: true,
      trimSpace: true,
      pagination: false,
      drag: false,
      breakpoints: {
        640: {
          perPage: 'auto',
          drag: 'free',
          flickPower: 200,
          snap: true,
          fixedWidth: '140px'
        },
      }
    }).mount();
  }
}

function looks() {
  var elms = document.getElementsByClassName("looks");
  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      perPage: 5,
      perMove: 1,
      gap: '20px',
      padding: { left: 20, right: 20 },
      arrows: false,
      focus: 0,
      live: true,
      trimSpace: true,
      pagination: false,
      drag: false,
      breakpoints: {
        640: {
          perPage: 'auto',
          drag: 'free',
          flickPower: 200,
          snap: true,
          fixedWidth: '140px'
        },
      }
    }).mount();
  }
}

function featured() {
  var elms = document.getElementsByClassName("featured");
  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      label: 'featured',
      perPage: 5,
      gap: '20px',
      padding: { left: 20, right: 20 },
      arrows: false,
      focus: 0,
      trimSpace: true,
      pagination: false,
      drag: false,
      fixedWidth: '180px',
      breakpoints: {
        640: {
          perPage: 'auto',
          drag: 'free',
          flickPower: 200,
          snap: true,
          fixedWidth: '196px'
        },
      }
    }).mount();
  }
}